import React from "react";
import {
  Drawer,
  Divider,
  Button,
  Space,
  Descriptions,
  Typography,
  Badge,
} from "antd";
import moment from "moment"; // Import moment
import { CURRENCY, getPayTypeLabel } from "../../constants/constent";
const { Title } = Typography;

const BookingOrderDrawer = ({ open, onClose, booking }) => {
  if (!booking || !booking.orders) {
    return null;
  }

  const { orders } = booking;

  // **Filter orders where o_tnx.status is "Pending"**
  const pendingOrders = orders.filter(
    (order) => order.o_tnx.status === "Pending"
  );

  // **Sum up the full bill details for pending orders**
  const totalSubtotal = pendingOrders
    .reduce((total, order) => total + parseFloat(order.subtotal), 0)
    .toFixed(2);
  const totalDiscount = pendingOrders
    .reduce((total, order) => total + parseFloat(order.discount), 0)
    .toFixed(2);
  const totalTax = pendingOrders
    .reduce((total, order) => total + parseFloat(order.tax), 0)
    .toFixed(2);
  const totalBill = pendingOrders
    .reduce((total, order) => total + parseFloat(order.total), 0)
    .toFixed(2);

  return (
    <Drawer
      size="large"
      placement="right"
      closable={false}
      onClose={onClose}
      open={open}
      footer={
        <Space direction="vertical" style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <div>
              <Title level={5}>
                <b>Rest Bill to Pay</b>
              </Title>
              <Descriptions bordered column={3}>
                <Descriptions.Item label="Subtotal">
                  {CURRENCY} {totalSubtotal}
                </Descriptions.Item>
                <Descriptions.Item label="Discount">
                  {CURRENCY} {totalDiscount}
                </Descriptions.Item>
                <Descriptions.Item label="Tax">
                  {CURRENCY} {totalTax}
                </Descriptions.Item>
                <Descriptions.Item label="Total">
                  <strong>
                    {CURRENCY} {totalBill}
                  </strong>
                </Descriptions.Item>
              </Descriptions>
            </div>
            <Button onClick={onClose}>
              <b>Close</b>
            </Button>
          </div>
        </Space>
      }
    >
      <Title level={5}>
        <b>Orders</b>
      </Title>

      {orders.map((order) => {
        const {
          id,
          total,
          subtotal,
          discount,
          tax,
          orderNotes,
          paymentMethod,
          created_at,
          updated_at,
          items,
          o_tnx,
        } = order;

        // **Format date using moment**
        const formattedCreatedAt = moment(created_at).format("MMMM Do, YYYY");
        const formattedUpdatedAt = moment(updated_at).format("MMMM Do, YYYY");

        return (
          <div key={id}>
            <Badge.Ribbon
              text={o_tnx.status}
              color={
                o_tnx.status === "Successful"
                  ? "green"
                  : o_tnx.status === "Failed"
                  ? "red"
                  : "red"
              }
            >
              <Title level={5}>
                <b>Order Details (ID: {id})</b>
              </Title>
            </Badge.Ribbon>

            <Descriptions bordered column={2}>
              <Descriptions.Item label="Total">
                {CURRENCY} {total}
              </Descriptions.Item>
              <Descriptions.Item label="Subtotal">
                {CURRENCY} {subtotal}
              </Descriptions.Item>
              <Descriptions.Item label="Discount">
                {CURRENCY} {discount}
              </Descriptions.Item>
              <Descriptions.Item label="Tax">
                {CURRENCY} {tax}
              </Descriptions.Item>
              <Descriptions.Item label="Payment Method">
                {getPayTypeLabel(paymentMethod)}
              </Descriptions.Item>
              <Descriptions.Item label="Order Notes">
                {orderNotes || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Created At">
                {formattedCreatedAt}
              </Descriptions.Item>
              <Descriptions.Item label="Updated At">
                {formattedUpdatedAt}
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            <Title level={5}>
              <b>Order Items</b>
            </Title>

            {items.map((item) => {
              const { product_name, product_amt, quantity, total_amt } = item;
              return (
                <Descriptions key={item.id} bordered column={2}>
                  <Descriptions.Item label="Product Name">
                    {product_name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Price">
                    {CURRENCY} {product_amt}
                  </Descriptions.Item>
                  <Descriptions.Item label="Quantity">
                    {quantity}
                  </Descriptions.Item>
                  <Descriptions.Item label="Total">
                    {CURRENCY} {total_amt}
                  </Descriptions.Item>
                </Descriptions>
              );
            })}

            <Divider />

            {o_tnx && (
              <>
                <Title level={5}>
                  <b>Transaction Details</b>
                </Title>
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Transaction ID">
                    {o_tnx.razorpay_payment_id || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Payment Status">
                    {o_tnx.status === "Successful" ? "Successful" : "Pending"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Payment Method">
                    {getPayTypeLabel(o_tnx.payment_method) || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Amount">
                    {CURRENCY} {o_tnx.amount}
                  </Descriptions.Item>
                  <Descriptions.Item label="Transaction Date">
                    {moment(o_tnx.created_at).format("YYYY-MM-DD HH:mm:ss")}
                  </Descriptions.Item>
                </Descriptions>
              </>
            )}

            <Divider />
          </div>
        );
      })}
    </Drawer>
  );
};

export default BookingOrderDrawer;
